import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useMemo, useState } from "react";
import { getJwt } from "@/utils/contacting";
export const AuthContext = createContext(null);
/**
 * Returns the user Web Token (JWT) and its decoded value
 *
 * @returns jwtDecode: null if no token is found, otherwise the decoded JWT
 * @returns validToken: null if no token is found, otherwise the JWT
 * @returns verifiedToken: true if the token was checked
 *
 */
export const AuthProvider = ({ children, oauthBaseUrl }) => {
    const [validToken, setValidToken] = useState(null);
    const [verifiedToken, setVerifiedToken] = useState(false);
    const [jwtDecode, setJwtDecode] = useState(null);
    // for Tracking purposes
    const authTrackingData = useMemo(() => {
        var _a;
        return ({
            uid: (_a = jwtDecode === null || jwtDecode === void 0 ? void 0 : jwtDecode.user_name) !== null && _a !== void 0 ? _a : jwtDecode === null || jwtDecode === void 0 ? void 0 : jwtDecode.uid,
            status: validToken ? "logged" : "unlogged",
        });
    }, [jwtDecode, validToken]);
    const authTrackingLegacyData = useMemo(() => {
        const userId = (jwtDecode === null || jwtDecode === void 0 ? void 0 : jwtDecode.uid) ? { user_id: jwtDecode === null || jwtDecode === void 0 ? void 0 : jwtDecode.uid } : {};
        return {
            ...userId,
            status: validToken ? 1 : 0,
        };
    }, [jwtDecode, validToken]);
    const getUserLoggedIn = async () => {
        const { jwt, decoded } = await getJwt(`${oauthBaseUrl}/refresh`);
        if (jwt) {
            setValidToken(jwt);
            setJwtDecode(decoded);
        }
        setVerifiedToken(true);
    };
    useEffect(() => {
        getUserLoggedIn();
        // we want to run the Effect just once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const authContextValue = useMemo(() => ({
        jwtDecode,
        validToken,
        verifiedToken,
        authTrackingData,
        authTrackingLegacyData,
    }), [
        jwtDecode,
        validToken,
        verifiedToken,
        authTrackingData,
        authTrackingLegacyData,
    ]);
    return (_jsx(AuthContext.Provider, { value: authContextValue, children: children }));
};
